/*
 * @Author: Teemo Ding
 * @Date: 2021-09-23 14:03:02
 * @LastEditTime: 2022-06-01 17:54:05
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Logistics/DestinationAddressLocalisation/config.tsx
 */
import Action from '@/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/TableActions';
import React from 'react';

export const columns = (onEdit, canEdit, { getI18n }) => [
  {
    title: getI18n(
      'storeLogistics.destinationAddressLocalisation.countryRegion',
    ),
    dataIndex: 'countryName',
    default: true,
    key: 'countryName',
    minWidth: 320,
  },
  {
    title: getI18n(
      'storeLogistics.destinationAddressLocalisation.destinationSupportedLanguages',
    ),
    dataIndex: 'supportedLanguages',
    default: true,
    key: 'supportedLanguages',
    minWidth: 576,
    childGenerate: (text) => (text || []).join(' , '),
  },
  {
    title: getI18n(
      'general.advancedFilters.commonStoreProductsWithTable.actions',
    ),
    dataIndex: 'name',
    default: true,
    key: 'name',
    minWidth: 192,
    childGenerate: (text, record, index) => (
      <Action
        disableEdit={!canEdit}
        onEdit={() => {
          onEdit(record);
        }}
      />
    ),
  },
];

export const breadcrumbData = ({ getI18n }) => [
  {
    url: '/',
    name: getI18n('general.sider.home'),
  },
  {
    url: '/settings',
    name: getI18n('general.sider.settings'),
  },
  {
    url: '/settings/logistics',
    name: getI18n('storeLogistics.config.logistics'),
  },
  {
    url: '/settings/logistics',
    name: getI18n('storeLogistics.index.destinationAddressLocalisation'),
  },
  {
    url: '',
    name: getI18n('storeLogistics.destinationAddressLocalisation.singapore'),
  },
];
